<template>
  <div>
    <GlobalHead></GlobalHead>
    <div class="container container-mobile">
      <div id="form-top" class="border-bottom mt-30 mb-40"></div>
      <div class="container-min">
        <div class="text-center min_block notfoundblock">
          <div style="margin-bottom: 2rem;" class="row">
            <div class="col-lg-6 col-sm-12">         
              <h1 class="h1">Aradığınız sayfa bulunamadı.</h1>
            </div>
            <div class="col-lg-6 col-sm-12">
              <img src="https://jolt-assets.s3.eu-central-1.amazonaws.com/template/ck404page.png" alt="404 not found">
            </div>
          </div>
        </div>
      </div><!-- /container-min -->
    </div><!-- /container -->
    <GlobalFoot></GlobalFoot>
  </div>
</template>
<script>
import GlobalHead from "../components/GlobalHead.vue"
import GlobalFoot from "../components/GlobalFooter.vue"
export default {
  components: {
    GlobalHead,
    GlobalFoot
  },
   props: {}
};
</script>
<style>
.notfoundblock img {
    width: 30%;
}
.notfoundblock .col-lg-6.col-sm-12 {
    margin-top: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
}
</style>